var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_174_5861)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 22.0007H17.4167V17.3779C17.4159 16.6592 17.1301 15.9702 16.622 15.462C16.1138 14.9539 15.4248 14.668 14.7061 14.6673H7.29392C6.57525 14.668 5.88622 14.9539 5.37805 15.462C4.86987 15.9702 4.58406 16.6592 4.58333 17.3779V22.0007H2.75V17.3779C2.75146 16.1732 3.23066 15.0183 4.08249 14.1665C4.93432 13.3146 6.08924 12.8354 7.29392 12.834H14.7061C15.9108 12.8354 17.0657 13.3146 17.9175 14.1665C18.7693 15.0183 19.2485 16.1732 19.25 17.3779V22.0007Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11C9.91221 11 8.84884 10.6774 7.94437 10.0731C7.0399 9.46874 6.33495 8.60976 5.91867 7.60476C5.50238 6.59977 5.39346 5.4939 5.60568 4.42701C5.8179 3.36011 6.34173 2.3801 7.11092 1.61092C7.8801 0.841726 8.86011 0.317902 9.92701 0.105683C10.9939 -0.106535 12.0998 0.00238307 13.1048 0.418665C14.1098 0.834947 14.9687 1.5399 15.5731 2.44437C16.1774 3.34884 16.5 4.41221 16.5 5.5C16.4985 6.95825 15.9186 8.35635 14.8875 9.38748C13.8563 10.4186 12.4582 10.9985 11 11ZM11 1.83334C10.2748 1.83334 9.56589 2.04838 8.96291 2.45128C8.35993 2.85418 7.88997 3.42683 7.61244 4.09683C7.33492 4.76683 7.26231 5.50407 7.40379 6.21533C7.54527 6.9266 7.89449 7.57994 8.40728 8.09273C8.92007 8.60552 9.57341 8.95474 10.2847 9.09622C10.9959 9.23769 11.7332 9.16508 12.4032 8.88756C13.0732 8.61004 13.6458 8.14007 14.0487 7.53709C14.4516 6.93411 14.6667 6.2252 14.6667 5.5C14.6667 4.52754 14.2804 3.59491 13.5927 2.90728C12.9051 2.21964 11.9725 1.83334 11 1.83334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_174_5861"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerLogo);
export default __webpack_public_path__ + "static/media/Customer_logo.7e33a5649295340d0e438419b0f9208b.svg";
export { ForwardRef as ReactComponent };